import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import CompanyCardEmpty from "app/pages/sales-intelligence/pages/company-analysis/components/cards/company-card/CompanyCardEmpty/CompanyCardEmpty";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";

import CompanyCard from "./CompanyCard";

const CompanyCardWithErrorBoundary = () => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                dataAutomation="company-card"
                renderContent={() => <CompanyCardEmpty />}
            />
        }
    >
        <CompanyCard />
    </ErrorBoundaryWithLogging>
);

export default CompanyCardWithErrorBoundary;
